import React from "react";
import { Link } from "react-router-dom";


export default function Features() {
  return (
    <section className="features py-5 text-center">
      <div className="container">
        <h2 className="fw-bold text-success mb-5">
          ببە بە یەکێک لە خێزانی یاسا
        </h2>
        <p className="mb-4">
          تۆی پارێزەر ئێستا دەتوانیت لە ڕێگای پڕکردنەوەی ئەم فۆڕمە ئەلیکتڕۆنییەوە
        </p>
        <p className="mb-5">
          زانیاریەکانت پڕ بکەیتەوە و ببیت بە یەکێک لە ئەندامەکانی خێزانی ئەپی یاسا
        </p>

        <div className="d-flex justify-content-center">
                              <Link
                            to="/form"
                            className="btn btn-success d-flex align-items-center justify-content-center"
                            style={{Height:"70px", Width:"200px", marginTop:20}}
                          >
                            تۆمارکردن
              </Link>
        </div>

      </div>
    </section>
  );
}
